import { render, staticRenderFns } from "./PerfectIcon.vue?vue&type=template&id=b60b7b52&"
import script from "./PerfectIcon.vue?vue&type=script&lang=js&"
export * from "./PerfectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports